// Utility function to get current branch ID from localStorage
export const getCurrentBranchId = () => {
    const branchId = localStorage.getItem("branch_id");
    if (!branchId) {
        console.warn(
            "No branch_id found in localStorage. Using default value 1."
        );
        return 1; // Fallback to default branch ID
    }
    return parseInt(branchId, 10);
};

// Utility function to get current client ID from localStorage
export const getCurrentClientId = () => {
    const clientId = localStorage.getItem("client_id");
    if (!clientId) {
        console.warn(
            "No client_id found in localStorage. Using default value 1."
        );
        return 1; // Fallback to default client ID
    }
    return parseInt(clientId, 10);
};

// Utility function to get current user data from localStorage
export const getCurrentUser = () => {
    const userStr = localStorage.getItem("user");
    if (!userStr) {
        console.warn("No user data found in localStorage.");
        return null;
    }
    try {
        return JSON.parse(userStr);
    } catch (error) {
        console.error("Error parsing user data from localStorage:", error);
        return null;
    }
};

// Utility function to check if user is logged in
export const isLoggedIn = () => {
    const token = localStorage.getItem("token");
    const branchId = localStorage.getItem("branch_id");
    return !!(token && branchId);
};

// Debug function to log all localStorage auth data
export const debugAuthData = () => {

};

// Function to clear all auth data (for debugging)
export const clearAuthData = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("branch_id");
    localStorage.removeItem("client_id");
    localStorage.removeItem("branch_name");
    localStorage.removeItem("user");
    console.log("All auth data cleared from localStorage");
};